







import { Component, Prop, Vue } from 'vue-property-decorator'

import CrossCheck from './CrossCheck.vue'
import InitialQuiz from './InitialQuiz.vue'

@Component({
  components: {
    CrossCheck,
    InitialQuiz,
  },
})
export default class GameStage extends Vue {
  @Prop() private readonly mode!: Game

  onGameExited(exit: GameExit) {
    this.$emit('onGameExit', exit)
  }
}
